import React from "react";
import { useDispatch } from "react-redux";

import ConversationsList from "./ConversationsList";
import { filterConversations } from "./../../store/action-creators";

const ConversationsContainer: React.FC = () => {
  const dispatch = useDispatch();

  const handleSearch = (searchString: string) => {
    dispatch(filterConversations(searchString));
  };

  return (
    <>
      <div className="ios-large-title">Messages</div>
      <label className="ios-search">
        <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
          <circle
            cx="10.5"
            cy="10.5"
            r="6.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
          />
          <path
            d="M15.5 15.5 21 21"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
          />
        </svg>
        <input
          aria-label="Search conversations"
          id="convoString"
          name="convoString"
          type="search"
          placeholder="Search"
          onChange={(e) => handleSearch(e.target.value)}
        />
      </label>
      <div className="ios-list">
        <ConversationsList />
      </div>
    </>
  );
};

export default ConversationsContainer;
